import React from 'react';
import { ProjectDataSection } from '../../proposal/sections/dach/ProjectDataSection';
import { PricingSection } from '../../proposal/sections/dach/PricingSection';
import { PageFooterDach } from './ContentPage2Dach';
import { DACH_DATA } from '../../proposal/data/dachData';
import { DraggableElement } from '../../DraggableElement';

/**
 * Page 3 (A4) – Pachtangebot + Preisoptionen.
 * Composer: setzt ProjectDataSection + PricingSection zusammen.
 */
export const ContentPage3Dach = ({ editMode, textEditMode = false, layoutEditLevel, proposalData = DACH_DATA, textContent, onTextChange, showMarkers = true, selectedElements, elementPositions, onSelectElement, onPositionChange }) => {
  const dragProps = {
    editMode,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
    showMarkers,
  };

  return (
    <div className="a4-page" data-testid="page-3-dach" style={{ display: 'flex', flexDirection: 'column' }}>
      {layoutEditLevel === 'detail' ? (
        <ProjectDataSection
          kundenadresse={proposalData.kundenadresse}
          kwp={proposalData.kwp_leistung}
          dachflaeche={proposalData.dachflaeche}
          laufzeit={proposalData.laufzeit}
          content={textContent?.page3?.project || proposalData.text?.page3?.project || DACH_DATA.text?.page3?.project}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S3-Pachtangebot" {...dragProps}>
          <ProjectDataSection
            kundenadresse={proposalData.kundenadresse}
            kwp={proposalData.kwp_leistung}
            dachflaeche={proposalData.dachflaeche}
            laufzeit={proposalData.laufzeit}
            content={textContent?.page3?.project || proposalData.text?.page3?.project || DACH_DATA.text?.page3?.project}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      {layoutEditLevel === 'detail' ? (
        <PricingSection
          kundenname={proposalData.kundenname}
          angebotsnummer={proposalData.angebotsnummer}
          einmalig={proposalData.einmalige_auszahlung}
          jaehrlich={proposalData.jaehrliche_auszahlung}
          gesamt={proposalData.gesamte_pachtzahlung}
          laufzeit={proposalData.laufzeit}
          vlProzent={proposalData.vl_prozent}
          offerVariant={proposalData.offerVariant}
          kwp={proposalData.kwp_leistung}
          content={textContent?.pricing || proposalData.text?.pricing || DACH_DATA.text?.pricing}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S3-Preisoptionen" {...dragProps} initialStyle={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          <PricingSection
            kundenname={proposalData.kundenname}
            angebotsnummer={proposalData.angebotsnummer}
            einmalig={proposalData.einmalige_auszahlung}
            jaehrlich={proposalData.jaehrliche_auszahlung}
            gesamt={proposalData.gesamte_pachtzahlung}
            laufzeit={proposalData.laufzeit}
            vlProzent={proposalData.vl_prozent}
            offerVariant={proposalData.offerVariant}
            kwp={proposalData.kwp_leistung}
            content={textContent?.pricing || proposalData.text?.pricing || DACH_DATA.text?.pricing}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      <PageFooterDach page={3} />
    </div>
  );
};
